import {IRange} from "@pg-design/inputs";
import {pluralize} from "@pg-mono/string-utils";

export const getRoomsMessage = ({lower, upper}: IRange<number | string>) => {
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    if (upper === "" && lower !== "") {
        return `${lower} i więcej pokoi`;
    }
    if (upper === lower && upper !== "") {
        return `${lower} ${roomsPluralize(lower as number)}`;
    }
    if (upper === 1) {
        return `1 ${roomsPluralize(upper)}`;
    }
    if (upper) {
        return `${lower || 1}-${upper} ${roomsPluralize(upper as number)}`;
    }
    return "";
};
import {IRange} from "@pg-design/inputs";
import {pluralize} from "@pg-mono/string-utils";

export const getRoomsMessage = ({lower, upper}: IRange<number | string>) => {
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    if (upper === "" && lower !== "") {
        return `${lower} i więcej pokoi`;
    }
    if (upper === lower && upper !== "") {
        return `${lower} ${roomsPluralize(lower as number)}`;
    }
    if (upper === 1) {
        return `1 ${roomsPluralize(upper)}`;
    }
    if (upper) {
        return `${lower || 1}-${upper} ${roomsPluralize(upper as number)}`;
    }
    return "";
};
